import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';
import {ComingSoon} from 'components/common/comingSoon';
export function SprintManager({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) {
  return (
    <ComingSoon
      text="Organize your work into manageable iterations to track progress and improve efficiency"
      imageSource={require('assets/illustrations/coming-soon-sprints.png')}
    />
  );
}
